import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { standardHttpOptions } from '@models';
import { Observable } from 'rxjs';
import { KigSettings, KIG_SETTINGS } from '../../../settings/kig-settings';

@Injectable()
export class SettingService {
  private apiUrl: string;

  constructor(private http: HttpClient,
              @Inject(KIG_SETTINGS) private settings: KigSettings) {
    this.apiUrl = this.settings.apiUrl;
  }

  // The link behind the home page "User Documentation" tile (Settings table key
  // UserDocumentationUrl). Empty when the setting has not been created.
  public getUserDocumentationUrl(): Observable<string> {
    return this.http.get(`${ this.apiUrl }/setting/userdocumentationurl`, { ...standardHttpOptions, responseType: 'text' });
  }
}
